// src/components/CompendiousMemorabilia.js

import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

const CompendiousMemorabilia = () => {
  return (
    // <Container fluid className="memorabilia-container">
    //   <Row className="justify-content-center text-center m-0">
        <Col md="8">
          {/* <div className="launched-container">
            <div className="line"></div>
            <p className="launched-text">LAUNCHED!</p>
            <div className="line"></div>
          </div>
          <h1 className="title">
            3rd <span className="edition">Edition</span> of Compendious Memorabilia (GVS 2023)
          </h1>
          <p className="subtitle">Invaluable knowledge shared at GVS</p>
          <Button className="order-button">Order Now</Button> */}
        </Col>
    //   </Row>
    // </Container>
  );
};

export default CompendiousMemorabilia;
